import React, { useContext, useState,useEffect } from "react";

import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

import FollowupTableComponent from "../../../components/tables/FollowupTableComponent";

import PageLayout from "../../../layouts/PageLayout";

import axios from "axios";
export default function AllFollowUps() {

    const AuthToken = localStorage.getItem("AuthUser");
    const [data,setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
          try {
            axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
            const response = await axios.get(
              process.env.REACT_APP_API_URL + "/all-family-followup"
            );
            setData(response.data.followups);
            console.log("pending attested families",response.data.followups);
           
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        fetchData();
      }, []);
   
  
    const mappedData = data.map((followup) => ({
        id: followup.id || "",
        fsf_id: followup.fsf_id || "",
        beneficiary_cnic: followup?.cnic || "",
        date_of_visit: followup?.date_of_visit || "",
        beneficiary_name: followup?.beneficiary_name || "",
        followup: followup.followup || "",
        user_name: followup?.user_name || "",
        status: "Pending", // Static value, replace if dynamic
        action: {
          edit: "edit",
          delete: "delete",
          view: "visibility",
        },
      }));
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{'All FollowUps'}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link"
                                style={{color:"#077834"}}>{"Home"}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link"
                                 style={{color:"#077834"}}>{"Families"}</Link></li>
                                <li className="mc-breadcrumb-item">{'FollowUps'}</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {/* {floats.map((float, index) => (
                    <Col key={ index } sm={6} lg={3}>
                        <FloatCardComponent 
                            variant={ float.variant }
                            digit={n(float.digit)}
                            title={t(float.title)}
                            icon={ float.icon }
                        />
                    </Col>
                ))} */}
                <Col xl={12}>
                    <div className="mc-card">
                        <Row>
                           
                            <Col xl={12}>
                                <FollowupTableComponent 
                                    thead={ ["FSF ID", "Beneficiary CNIC", "Beneficiary Name", "Followup", "Date of Visit", "Follow-up Entered By", "Action"] } 
                                    tbody={ mappedData } 
                                />
                                {/* <PaginationComponent /> */}
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}
